
import { useEffect, useState } from "react";
import rideService from "src/services/rideService";

export default function RiderRideHistory({ riderId, isOpen, onClose }) {


  const [allRides, setallRides] = useState([]);
  const [totalCommission, setTotalCommission] = useState();
  const [totalEarning, setTotalEarning] = useState();
  useEffect(() => {

    rideService.getRiderRideHistory(riderId).then((res) => {
      if (res.status == 200) {
        setallRides(res.data.completedRides);
        setTotalCommission(res.data.totalCommission);
        setTotalEarning(res.data.totalEarning);
      }
    })
  }, [])
  const convertToBoolean = (value) => {
    return value === 1 ? true : false;
  };
  return (
    <>
      <div className={` inset-0 ${isOpen ? 'block' : 'hidden'}  overflow-x-auto mt-20`}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 flex items-center justify-center">

          <div className="bg-white p-6 rounded-lg shadow-lg max-h-full overflow-y-auto  w-1/2 h-1/2">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="bg-blue-500 text-white text-sm">
                  {/* <th className="px-4 py-2 text-left border-b border-r border-gray-300 text-sm">ID</th> */}
                  <th className="px-4 py-2 border-b border-r border-gray-300">Starting Point</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Destination</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Distance</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Price</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Ride Completed</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Ride Cancelled</th>
                  <th className="px-4 py-2 border-b border-gray-300">Date</th>
                </tr>
              </thead>
              <tbody className="text-gray-600">
                {allRides.map((ride) => {
                  const dateString = ride.created_at; // Assuming 'created_at' is in ISO 8601 format
                  const dateObject = new Date(dateString);
                  const formattedDate = dateObject.toLocaleDateString();
                  const formattedTime = dateObject.toLocaleTimeString();
                  const dateTimeString = `${formattedDate} ${formattedTime}`;
                  return (
                    <tr key={ride.id} className="border-b border-gray-200 hover:bg-gray-100">
                      {/* <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.id}</td> */}
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.starting_point}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.destination}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.distance}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.price}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.completed ? "true" : "false"}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{ride.cancelled ? "true" : "false"}</td>
                      <td className="px-4 py-2 text-center">{dateTimeString}</td>
                    </tr>
                  );

                })}
              </tbody>
            </table>
            {allRides.length > 0 ? <>
              <div className="mt-4 max-w-xs mx-auto">
                
                <button
                  onClick={onClose}
                  className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  Close
                </button>
              </div>

            </> :

              <>
                <center><h2>No Record</h2></center>
                <button
                  onClick={onClose}
                  className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  Close
                </button>
              </>}

          </div>

        </div>

      </div>

    </>
  );
}

// export async function getServerSideProps(context) {
//   const { riderId } = context.query;

//   return {
//     props: {
//       riderId: riderId || null, // Handle the case where id is undefined
//     },
//   };
// }